import * as React from 'react';
import { connect } from 'react-redux';

import { DeprecatedEventWrapper } from '../../../../common/analyticsEvents/DeprecatedEventWrapper';
import { IReactTranslateService } from '../../../../common/react/IReactTranslateService';
import { Location } from '../../../../common/react/Location';
import { imgPath } from '../../../../common/utilities/ImgUrl';
import { siteUrlsSelector } from '../../../selectors/SiteUrlsSelectors';
import { SpacesSiteUrls } from '../../../spaces/SpacesSiteUrls';
import { AppState } from '../../../state/AppState';
import { MapStateToProps } from '../../../utils/ConnectUtils';
import { GuidePanel } from '../../components/GuidePanel';

export class AddUserPanel extends React.Component<AddUserPanel.Props, AddUserPanel.State> {

  constructor(props: AddUserPanel.Props) {
    super(props);
  }

  private static imageUrl = imgPath('getting_started_share.png');

  private inviteUserCallback(text: string, content: string) {
    // Deprecated, use TelemetryService instead of AnalyticsEvents.
    this.props.analyticsEvents.sendGettingStartedEvent('invite_others_cta', text, content);
    // We have to pass along a reason when we close a modal, even though we aren't processing it.
    this.props.closeModalFn();

    Location.instance.setUrl(this.props.urls.usersUrl());
  }

  public render(): any {
    const content = this.props.translate('gettingStarted_inviteUsersContent');
    const ctaText = this.props.translate('gettingStarted_inviteUsersCTA_2');
    const callback = () => this.inviteUserCallback(ctaText, content);

    return (
      <GuidePanel
        imgUrl={AddUserPanel.imageUrl }
        content={ content }
        callToActionText={ ctaText }
        callback={ callback }
      />
    );
  }
}

export module AddUserPanel {
  export interface StateProps {
    readonly urls: SpacesSiteUrls;
  }

  export interface OwnProps {
    readonly translate: IReactTranslateService;
    readonly analyticsEvents: DeprecatedEventWrapper;
    readonly closeModalFn: () => void;
  }

  export type Props = OwnProps & StateProps;

  export interface State {}
}

const mapStateToProps: MapStateToProps<AddUserPanel.StateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
});

export const ConnectedAddUserPanel: React.ComponentClass<AddUserPanel.OwnProps> = connect(mapStateToProps)(AddUserPanel);
